
// - Basic settings - //

  // server
  export const API_URL = 'https://api.heimstaden.qtcloud.cz';

  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyDYNQYgSxetOOxyKCsBEotiYEIyAX7HK0M';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  // title
  export const APP_TITLE = 'Rezervační systém'; // 'Rezervační systém'

  // single office mode
  export const SINGLE_OFFICE_MODE = false;

  // graph statistics
  // - default: month or year
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1
  //  - main color in header and selected button
  export const COLOR_1 = '#ff5000';
  export const COLOR_1_BORDER_BOTTOM = 'rgba(207, 111, 35, 0.82)';
  export const COLOR_1_BORDER_LEFT = 'rgba(250, 147, 65, 0.82)';

  // color 2
  //  - color in header under logo
  export const COLOR_2 = '#ff5000';
  export const COLOR_2_BORDER_BOTTOM = 'rgba(153, 84, 27, 0.65)';
  export const COLOR_2_BORDER_RIGHT = 'rgba(137, 78, 29, 0.65)';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#2e3647';
  export const COLOR_3_BORDER_RIGHT = 'rgba(73, 79, 94, 0.71)';

// -------------------- //
